import hm from './hamburger-menu'

const setContentPosition = (headerHeight, $mainContainer) => {
  $mainContainer.style.paddingTop = headerHeight + 'px'
}

const setActiveMenuItem = ($items) => {
  $items.forEach(($item, i) => {
    let   target  = $item.getAttribute('href')
          target  = target.replace('/', '');
    const $target = document.querySelector(target)
    const windowScrollTop = window.pageYOffset + (window.innerHeight / 3)
    // $item.classList.remove('--active')

    if ($target && windowScrollTop >= $target.offsetTop) {
      $items.forEach(($item, i) => {
        $item.classList.remove('--active')
      })
      $item.classList.add('--active')

      return false
    }

    $item.classList.remove('--active')
  })
}

const setNavShadow = ($header) => {
  // if (window.pageYOffset >= $header.getBoundingClientRect().height) {
  if (window.pageYOffset >= 1) {
    $header.classList.add('--shadow')

    return false
  }

  $header.classList.remove('--shadow')
}

class mainMenu {
  constructor() {
    this.dom = {
      'header': document.querySelector('header:not(.nav-backoffice)'),
      'mainMenu': document.querySelector('header:not(.nav-backoffice) .main-menu'),
      'mainContainer': document.querySelector('.main-container'),
      'anchorAnimated': document.querySelectorAll('header:not(.nav-backoffice) [anchor-animated]'),
    }
    if (this.dom.header) {
      this.state = {
        'headerHeight': this.dom.header.getBoundingClientRect().height
      }
    }
  }
  init() {
    if (this.dom.mainMenu) {
      new hm().main()

      setContentPosition(this.state.headerHeight, this.dom.mainContainer)
      window.addEventListener('resize', () => {
        if (this.dom.header.getBoundingClientRect().height !== this.state.headerHeight) {
          this.state.headerHeight = this.dom.header.getBoundingClientRect().height
          setContentPosition(this.state.headerHeight, this.dom.mainContainer)
        }
      })

      setActiveMenuItem(this.dom.anchorAnimated)
      setNavShadow(this.dom.header)
      window.addEventListener('scroll', () => {
        setActiveMenuItem(this.dom.anchorAnimated)
        setNavShadow(this.dom.header)
      })
    }
  }
}

export default mainMenu
